import { useGetAllArticulosByProject } from 'lib/react-query/queries'
import { useParams } from 'react-router-dom'
import ArticulosRow from './ArticulosRow'
import { useState, useEffect } from 'react'
import ArticulosTableLoader from 'components/Loaders/ArticulosTableLoader'
import Loader from 'components/Spinner/Loader'
import { useVersionModel } from 'hooks/useVersionModel'
import { TABLE_HEADER_ARTICULOS } from 'utils/constant/constantsArticulos'
import { useArticulosTablePage } from 'context/ArticulosTablePageContext'
import Pagination from 'components/ui/Pagination/Pagination'
import { ArticulosTable_v2 } from './ArticulosTable_v2'

const ArticulosTable = () => {
  const { idProject } = useParams()
  const { currentVersion } = useVersionModel()
  const { searchedValue, sort } = useArticulosTablePage()

  // Configuración de la paginación
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  // Resetea la página 1 cuando cambie filtro o orden
  useEffect(() => {
    setCurrentPage(1)
  }, [searchedValue, sort])

  const { data, isLoading, isError } = useGetAllArticulosByProject(idProject, {
    limit: itemsPerPage,
    filter: searchedValue || '',
    version: currentVersion,
    page: currentPage,
    sort: sort || '',
  })
    
  if (isLoading) return <ArticulosTableLoader />
  if (isError) return <p>Error al cargar los datos: {isError.message}</p>

  if (data?.data?.articulos?.length === 0)
    return <p className="not-articulos-text">Ningún artículo encontrado</p>

  // Obtener datos de articulos y paginación
  const articulos = data.data.articulos
  if (!articulos) return <Loader />

  const totalItems = data.data.total || 0
  const totalPages = data.data.totalPages || Math.ceil(totalItems / itemsPerPage)

  return (
    <div
      className="fabrica-matriculas-table-container"
      style={{ flex: 1, overflowY: 'auto' }}
    > 
          <ArticulosTable_v2 articulos={articulos}/>
      <br />
      {/* Sólo muestra la paginación si hay más de 1 página */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePage={setCurrentPage}
        />
      )}
    </div>
  )
}

export default ArticulosTable
